module.exports = __webpack_public_path__ + "static/media/tw.bbb044fc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flags-select/flags/tw.svg
// module id = 1614
// module chunks = 0